import moment from "moment";
import { BehaviorSubject } from "rxjs";
import api, { IDataResponse, apiNoLoading, STATUS_CODE } from "src/framework/providers/api";
import { IParcelasDisponiveis, LIST_TIPO_CONTA_DISTRIBUIDORES, LIST_TIPO_CONTA_REVENDAS, TIPO_CONTA_COLABORADOR, TIPO_CONTA_EV, TParametro } from "src/types";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import pagamentoProvider from "src/providers/pagamentos/PagamentosProvider";
import { cartoesBandeiraProvider } from "src/providers/financeiro/CartoesBandeira";
import { financiamentosProvider } from "src/providers/pagamentos/FinancimentosProvider";
import { financeirasProvider } from "src/providers/financeiro/Financeiras";
import { ITermosAceitePagamento, ITermosPagamentos } from "src/providers/cadastros/TermosAceiteProvider/types";

export type CacheType<T = any> = {
    expires: number;
    data: T;
    loading: boolean;
}

const getChacheTime = (customCacheTime?: number): number => {
    return Number(moment().add(customCacheTime || process.env.REACT_APP_ENV_CACHE_EXPIRES, "minute").format("x"))
}

export const estados$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const cidades$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});


export const grupoEstrutura$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const limitacoes$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const componentes$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const distribuidores$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const revendas$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const evs$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const engenharia$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const paises$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const documentosPagamentos$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const bancos$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const formasPagamentoTextoInformativo$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const cartoesBandeiras$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
})

export const financeiras$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
})

export const parcelas$ = new BehaviorSubject<CacheType<IParcelasDisponiveis>>({
    data: { parcelas: [] },
    expires: 0,
    loading: false,
})


export const termosAceite$ = new BehaviorSubject<ITermosPagamentos | null>(null);


export const qrCodeFINAME$ = new BehaviorSubject<CacheType<TParametro>>({
    data: { id: "FINANCIAMENTO_FINAME_IMAGEM", valor: "" },
    expires: 0,
    loading: false,
})


export const getImageQrCodeFINAME = async (): Promise<any> => {
    const now = moment().format("x")
    const { expires, loading } = qrCodeFINAME$.getValue();
    if (expires < Number(now) && !loading) {
        qrCodeFINAME$.next({ ...qrCodeFINAME$.getValue(), loading: true })
        console.log("obtendo cache do qrCode FINAME ...")
        const response: IDataResponse = await apiNoLoading.get({
            url: `pagamentos/cartas_credito/parametro_finame`,
        });

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            const newExpireDate = getChacheTime()
            qrCodeFINAME$.next({
                data: data,
                expires: newExpireDate,
                loading: false
            })
            return data;
        }
        return qrCodeFINAME$.getValue().data;
    }

    return qrCodeFINAME$.getValue().data;

}

export const getEstados = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = estados$.getValue();
    if (expires < Number(now) && !loading) {
        estados$.next({ ...estados$.getValue(), loading: true })
        console.log("obtendo cache dos Estados...")
        const response: IDataResponse = await apiNoLoading.get({
            url: `estados?orderby=nome`,
        });

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            const newExpireDate = getChacheTime()
            estados$.next({
                data: data,
                expires: newExpireDate,
                loading: false
            })
            return data;
        }
        return estados$.getValue().data;
    }

    return estados$.getValue().data;

}


export const getCidades = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = cidades$.getValue();
    if (expires < Number(now) && !loading) {
        cidades$.next({ ...cidades$.getValue(), loading: true })
        console.log("obtendo cache de cidades....")
        const response: IDataResponse = await apiNoLoading.get({
            url: `cidades?orderby=estado_id,nome`,
        });

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            const newExpireDate = getChacheTime()
            cidades$.next({
                data: data,
                expires: newExpireDate,
                loading: false
            })
            return data;
        }
        return cidades$.getValue().data;
    }

    return cidades$.getValue().data;

}

export const getGruposEstrutura = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = grupoEstrutura$.getValue();
    if (expires < Number(now) && !loading) {
        grupoEstrutura$.next({ ...grupoEstrutura$.getValue(), loading: true })
        console.log("obtendo cache de grupos de estrutura....")
        const response: IDataResponse = await apiNoLoading.get({
            url: `/estoque/grupos_estruturas?orderby=nome`,
        });

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            const newExpireDate = getChacheTime()
            grupoEstrutura$.next({
                data: data,
                expires: newExpireDate,
                loading: false
            })
            return data;
        }
        return grupoEstrutura$.getValue().data;
    }

    return grupoEstrutura$.getValue().data;

}

export const getLimitacoesProjetos = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = limitacoes$.getValue();
    if (expires < Number(now) && !loading) {
        limitacoes$.next({ ...limitacoes$.getValue(), loading: true })
        console.log("obtendo cache de limitações projetos....")
        const response: IDataResponse = await apiNoLoading.get({
            url: `/limitacoes_projetos/?orderby=descricao`,
        });

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            const newExpireDate = getChacheTime()
            limitacoes$.next({
                data: data,
                expires: newExpireDate,
                loading: false
            })
            return data;
        }
        return limitacoes$.getValue().data;
    }

    return limitacoes$.getValue().data;

}

export const getComponentes = async (): Promise<CacheType | null> => {
    const now = moment().format("x")
    const _cached = LocalStorage.get<CacheType | null>("solar.componentes", true);

    const expires = _cached?.expires || 0;
    const loading = _cached?.loading || false;

    if (expires < Number(now) && !loading) {
        LocalStorage.set("solar.componentes", { ..._cached, loading: true }, true)
        console.log("obtendo cache de componentes projetos....")
        const response: IDataResponse = await apiNoLoading.get({
            url: `/estoque/componentes?reduce`,
        });

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            const newExpireDate = getChacheTime()

            const cache: CacheType = {
                data: data,
                expires: newExpireDate,
                loading: false
            }

            LocalStorage.set("solar.componentes", cache, true)

            return cache;
        }
        return null;
    }

    return LocalStorage.get("solar.componentes", true) || null;

}


export const getDistribuidores = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = distribuidores$.getValue();
    if (expires < Number(now) && !loading) {
        distribuidores$.next({ ...distribuidores$.getValue(), loading: true })
        console.log("obtendo cache de componentes projetos....")
        const response: IDataResponse = await apiNoLoading.get({
            url: `/cadastros/contas?tipo_conta_id_in=${LIST_TIPO_CONTA_DISTRIBUIDORES}&orderby=fantasia`,
        });

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            const newExpireDate = getChacheTime()
            distribuidores$.next({
                data: data,
                expires: newExpireDate,
                loading: false
            })
            return data;
        }
        return distribuidores$.getValue().data;
    }

    return distribuidores$.getValue().data;

}

export const getRevendas = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = revendas$.getValue();
    if (expires < Number(now) && !loading) {
        revendas$.next({ ...revendas$.getValue(), loading: true })
        console.log("obtendo cache de componentes projetos....")
        const response: IDataResponse = await apiNoLoading.get({
            url: `/cadastros/contas?tipo_conta_id_in=${LIST_TIPO_CONTA_REVENDAS}&orderby=nome`,
        });

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            const newExpireDate = getChacheTime()
            revendas$.next({
                data: data,
                expires: newExpireDate,
                loading: false
            })
            return data;
        }
        return revendas$.getValue().data;
    }

    return revendas$.getValue().data;

}

export const getEvs = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = evs$.getValue();
    if (expires < Number(now) && !loading) {
        evs$.next({ ...evs$.getValue(), loading: true })
        console.log("obtendo cache de componentes projetos....")
        const response: IDataResponse = await apiNoLoading.get({
            url: `/cadastros/contas?tipo_conta_id_in=${TIPO_CONTA_EV}&orderby=nome`,
        });

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            const newExpireDate = getChacheTime()
            evs$.next({
                data: data,
                expires: newExpireDate,
                loading: false
            })
            return data;
        }
        return evs$.getValue().data;
    }

    return evs$.getValue().data;

}

export const getAnalistasEngenharia = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = engenharia$.getValue();
    if (expires < Number(now) && !loading) {
        engenharia$.next({ ...engenharia$.getValue(), loading: true })
        console.log("obtendo cache de componentes projetos....")
        const response: IDataResponse = await apiNoLoading.get({
            url: `/cadastros/contas?tipo_conta_id_in=${TIPO_CONTA_COLABORADOR}&orderby=nome`,
        });

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            const newExpireDate = getChacheTime()
            engenharia$.next({
                data: data,
                expires: newExpireDate,
                loading: false
            })
            return data;
        }
        return engenharia$.getValue().data;
    }

    return engenharia$.getValue().data;

}

export const getPaises = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = paises$.getValue();
    if (expires < Number(now) && !loading) {
        paises$.next({ ...paises$.getValue(), loading: true })
        console.log("obtendo cache de paises....")
        const response: IDataResponse = await apiNoLoading.get({
            url: `paises?orderby=nome`,
        });

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            const newExpireDate = getChacheTime()
            paises$.next({
                data: data,
                expires: newExpireDate,
                loading: false
            })
            return data;
        }
        return paises$.getValue().data;
    }

    return paises$.getValue().data;

}

export const getUpload = async (): Promise<CacheType | null> => {
    const now = moment().format("x")

    const _cached = LocalStorage.get<CacheType | null>("solar.uploadInfo", true);

    const expires = _cached?.expires || 0;
    const loading = _cached?.loading || false;

    if (expires < Number(now) && !loading) {
        LocalStorage.set("solar.uploadInfo", { ..._cached, loading: true }, true)
        console.log("obtendo cache de informações do upalod....")
        const response: IDataResponse = await apiNoLoading.get({
            url: `/uploads`,
        });

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            const newExpireDate = getChacheTime()

            const cache = {
                data: data,
                expires: newExpireDate,
                loading: false
            }

            LocalStorage.set("solar.uploadInfo", cache, true);
            return cache;
        }
        return null;
    }

    return _cached?.data || null;

}

export const verficarServicoCupomDesconto = async (): Promise<CacheType | null> => {
    const now = moment().format("x")

    const _cached = LocalStorage.get<CacheType | null>("solar.servicoCupom", true);

    const expires = _cached?.expires || 0;
    const loading = _cached?.loading || false;

    if (expires < Number(now) && !loading) {
        LocalStorage.set("solar.servicoCupom", { ..._cached, loading: true }, true)
        console.log("obtendo cache de informações do upalod....")
        const response: IDataResponse = await pagamentoProvider.verificarStatusServicoCupom();

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            const newExpireDate = getChacheTime(0.01)

            const cache = {
                data: data,
                expires: newExpireDate,
                loading: false
            }

            LocalStorage.set("solar.servicoCupom", cache, true);
            return cache;
        }
        return null;
    }

    return _cached?.data || null;

}

export const getDocumentosPagamentos = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = documentosPagamentos$.getValue();
    if (expires < Number(now) && !loading) {
        documentosPagamentos$.next({ ...documentosPagamentos$.getValue(), loading: true })
        console.log("obtendo cache de documentos....")
        const response: IDataResponse = await apiNoLoading.get({
            url: `cadastros/documentos_pagamentos?orderby=ordem`,
        });

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            const newExpireDate = getChacheTime()
            documentosPagamentos$.next({
                data: data,
                expires: newExpireDate,
                loading: false
            })
            return data;
        }
        return documentosPagamentos$.getValue().data;
    }

    return documentosPagamentos$.getValue().data;

}

export const getBancos = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = bancos$.getValue();
    if (expires < Number(now) && !loading) {
        bancos$.next({ ...bancos$.getValue(), loading: true })
        console.log("obtendo cache de bancos....")
        const response: IDataResponse = await apiNoLoading.get({
            url: `financeiro/bancos/listar?orderby=id`,
        });

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            const newExpireDate = getChacheTime();
            bancos$.next({
                data: data,
                expires: newExpireDate,
                loading: false
            })
            return data;
        }
        return bancos$.getValue().data;
    }

    return bancos$.getValue().data;

}

export const getFormasPagamentoTextoInformativo = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = formasPagamentoTextoInformativo$.getValue();
    if (expires < Number(now) && !loading) {
        formasPagamentoTextoInformativo$.next({ ...formasPagamentoTextoInformativo$.getValue(), loading: true })
        console.log("obtendo cache de formas pagamentos....")
        const response: IDataResponse = await apiNoLoading.get({
            url: `financeiro/formas_pagamento/listarTextoInformativo?orderby=nome`,
        });

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            const newExpireDate = getChacheTime();
            formasPagamentoTextoInformativo$.next({
                data: data,
                expires: newExpireDate,
                loading: false
            })
            return data;
        }
        return formasPagamentoTextoInformativo$.getValue().data;
    }

    return formasPagamentoTextoInformativo$.getValue().data;

}

export const getCartoesBandeiras = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = cartoesBandeiras$.getValue();
    if (expires < Number(now) && !loading) {
        cartoesBandeiras$.next({ ...cartoesBandeiras$.getValue(), loading: true })
        console.log("obtendo cache das bandeiras dos cartões....")
        const response: IDataResponse = await cartoesBandeiraProvider.list()

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            const newExpireDate = getChacheTime();
            cartoesBandeiras$.next({
                data: data,
                expires: newExpireDate,
                loading: false
            })
            return data;
        }
        return cartoesBandeiras$.getValue().data;
    }

    return formasPagamentoTextoInformativo$.getValue().data;
}

export const getProfissoes = async (): Promise<CacheType | null> => {
    const now = moment().format("x")

    const _cached = LocalStorage.get<CacheType | null>("solar.profissoes", true);

    const expires = _cached?.expires || 0;
    const loading = _cached?.loading || false;

    if (expires < Number(now) && !loading) {
        LocalStorage.set("solar.profissoes", { ..._cached, loading: true }, true)
        console.log("obtendo cache de informações de profissoes....")
        const response: IDataResponse = await financiamentosProvider.getProfissoes()

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            const newExpireDate = getChacheTime()

            const cache = {
                data: data,
                expires: newExpireDate,
                loading: false
            }

            LocalStorage.set("solar.profissoes", cache, true);
            return cache;
        }
        return null;
    }

    return _cached?.data || null;

}

export const getFinanceiras = async (): Promise<CacheType | null> => {
    const now = moment().format("x")

    const _cached = LocalStorage.get<CacheType | null>("solar.financeiras", true);

    const expires = _cached?.expires || 0;
    const loading = _cached?.loading || false;

    if (expires < Number(now) && !loading) {
        LocalStorage.set("solar.financeiras", { ..._cached, loading: true }, true)
        console.log("obtendo cache de informações de financeiras...")
        
        financeirasProvider.setHttpClient(apiNoLoading)
        const response: IDataResponse = await financeirasProvider.list()
        financeirasProvider.setHttpClient(api)
        
        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            const newExpireDate = getChacheTime()

            const cache = {
                data: data,
                expires: newExpireDate,
                loading: false
            }

            LocalStorage.set("solar.financeiras", cache, true);
            return cache;
        }
        return null;
    }

    return _cached?.data || null;

}


export const getParcelasDisponiveis = async (): Promise<CacheType | null> => {
    const now = moment().format("x")

    const _cached = LocalStorage.get<CacheType | null>("solar.parcelasDisponiveis", true);

    const expires = _cached?.expires || 0;
    const loading = _cached?.loading || false;

    if (expires < Number(now) && !loading) {
        LocalStorage.set("solar.parcelasDisponiveis", { ..._cached, loading: true }, true)
        console.log("obtendo cache de informações das parcelas diponíveis...")

        pagamentoProvider.setHttpClient(apiNoLoading)
        const response: IDataResponse = await pagamentoProvider.parcelasDisponiveis()
        pagamentoProvider.setHttpClient(api)
        
        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            const newExpireDate = getChacheTime()

            const cache = {
                data: data,
                expires: newExpireDate,
                loading: false
            }

            LocalStorage.set("solar.parcelasDisponiveis", cache, true);
            return cache;
        }
        return null;
    }

    return _cached?.data || null;

}